import React, { useState } from 'react';
import SEO from '../components/SEO';
import '../styles/Connections.css';
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';

const Connections = () => {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    alert('Successfully subscribed to our newsletter!');
    setEmail('');
  };

  const socialPlatforms = [
    { id: 1, name: 'YouTube', icon: FaYoutube, color: '#FF0000', description: 'Watch our content', url: 'https://youtube.com/@bookmycamera2904?si=4PSMMr6bDhDk95ehadd' },
    { id: 2, name: 'Instagram', icon: FaInstagram, color: '#E4405F', description: 'See our visual story & Photography Events', url: process.env.REACT_APP_INSTAGRAM || 'https://www.instagram.com/bmc__events?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==', secondaryUrl: process.env.REACT_APP_INSTAGRAM_SECONDARY || null, secondaryName: 'Instagram 2' },
    { id: 3, name: 'Facebook', icon: FaFacebook, color: '#1877F2', description: 'Join our community', url: 'https://www.facebook.com/share/1LuQFB4dPx/', secondaryUrl: 'https://www.facebook.com/share/17LUMaKMwJ/', secondaryName: 'Facebook Page 2' },
  ];

  return (
    <>
      <SEO 
        title="Connections - BookMyCamera | Connect With Us"
        description="Connect with BookMyCamera on social media. Follow us for photography tips, latest updates, and exclusive offers on camera equipment rental in Bangalore."
        keywords="bookmycamera social media, photography community bangalore, camera rental updates"
      />
      <div className="connections-container">
      <div className="connections-header">
        <h1>Stay Connected</h1>
        <p>Join our community and stay updated with the latest news and insights</p>
      </div>

      <section className="social-section">
        <h2>Follow Us On Social Media</h2>
        <div className="social-grid">
          {socialPlatforms.map(platform => {
            const IconComponent = typeof platform.icon === 'function' ? platform.icon : null;
            
            // Special handling for platforms with two links (Instagram and Facebook)
            if (platform.secondaryUrl) {
              const isInstagram = platform.name === 'Instagram';
              const isFacebook = platform.name === 'Facebook';
              
              return (
                <div key={platform.id} className={`social-card ${isInstagram ? 'instagram-card' : isFacebook ? 'facebook-card' : ''}`}>
                  <div className="social-icon">
                    {IconComponent ? <IconComponent style={{ color: platform.color }} /> : platform.icon}
                  </div>
                  <h3>{platform.name}</h3>
                  <p>{platform.description}</p>
                  <div className={isInstagram ? 'instagram-links' : isFacebook ? 'facebook-links' : 'social-links'}>
                    {isInstagram ? (
                      <>
                        <a 
                          href={platform.url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="follow-button"
                          onClick={(e) => e.stopPropagation()}
                        >
                          BMC Events
                        </a>
                        {platform.secondaryUrl ? (
                          <a 
                            href={platform.secondaryUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="follow-button"
                            onClick={(e) => e.stopPropagation()}
                          >
                            Other
                          </a>
                        ) : null}
                      </>
                    ) : isFacebook ? (
                      <>
                        <a 
                          href={platform.url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="follow-button"
                          onClick={(e) => e.stopPropagation()}
                        >
                          Facebook Page 1
                        </a>
                        <a 
                          href={platform.secondaryUrl} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="follow-button"
                          onClick={(e) => e.stopPropagation()}
                        >
                          Facebook Page 2
                        </a>
                      </>
                    ) : null}
                  </div>
                </div>
              );
            }
            
            return (
              <a 
                key={platform.id} 
                href={platform.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-card"
                style={{ textDecoration: 'none', display: 'block' }}
              >
                <div className="social-icon">
                  {IconComponent ? <IconComponent style={{ color: platform.color }} /> : platform.icon}
                </div>
                <h3>{platform.name}</h3>
                <p>{platform.description}</p>
                <div className="follow-button">
                  Follow Us
                </div>
              </a>
            );
          })}
        </div>
      </section>

      <section className="newsletter-section">
        <h2>Subscribe To Our Newsletter</h2>
        <p>Get the latest updates, insights, and exclusive offers delivered to your inbox</p>
        <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
          <input
            type="email"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">Subscribe Now</button>
        </form>
      </section>
    </div>
    </>
  );
};

export default Connections;
